import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Packages from "./components/Packages";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ScrollProgress from "./components/ScrollProgress";
import Process from "./components/Process";
import Projects from "./components/Projects";
import AOS from "aos";
import "aos/dist/aos.css";


function App() {



  // Init AOS animations
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      easing: "ease-out",
    });
  }, []);



  return (
    <div>
    

      {/* Website content after loader finishes */}
      { 
        <>
          <Navbar />
          <ScrollProgress />
          <Home />
          <About />
          <Services />
          <Process />
          <Projects />
          <Packages />
  
          <Contact />
          <Footer />
          <BackToTop />
        </>
      }
    </div>
  );
}

export default App;
